import React from "react";
import { P_Props } from "./CategoryCard1.type";
import clsx from "clsx";
import { Avatar } from "@material-ui/core";
import { getFirstChar, ImageUtil, loadCallback } from "../../../utils";
import { MoreHoriz as MoreHorizIcon } from "@material-ui/icons";

const CategoryCard1Presenter: React.FC<P_Props> = (props) => {
  const classes = clsx({ "category-card-1": true, active: props.selected });
  const buildPictureSrc = props.buildPictureSrc || ImageUtil.buildProductCategoryImgSrc;

  return (
    <>
      <div
        className={classes}
        onClick={() => {
          props.onClick();
        }}
      >
        {props.isAvatar && <Avatar alt={props.name} src={props.picture ? buildPictureSrc(props.picture) : undefined}>
          {props.name !== undefined ? getFirstChar(props.name) : ""}
        </Avatar>}
        <div className="category-card-1__name">{props.name}</div>

        {props.onActionClick && 
        <div
          className="category-card-1__action"
          onClick={(e) => {
            e.stopPropagation();
            loadCallback(props.onActionClick, e);
          }}
        >
          <MoreHorizIcon style={{ fontSize: "2.2rem" }} />
        </div> }
      </div>
    </>
  );
};

export default CategoryCard1Presenter;
